export default {
  methods: {
    getStatsTagFilters(tags = []) {
      const defaultTags = [
        {
          value: 'sku',
          label: this.$t('APP.STATS.FILTERS.TAG.SKU'),
        },
        {
          value: 'app_version',
          label: this.$t('APP.STATS.FILTERS.TAG.APP_VERSION'),
        },
        {
          value: 'sdk_version',
          label: this.$t('APP.STATS.FILTERS.TAG.SDK_VERSION'),
        },
        {
          value: 'province',
          label: this.$t('APP.STATS.FILTERS.TAG.PROVINCE'),
        },
        {
          value: 'device_product_id',
          label: this.$t('APP.STATS.FILTERS.TAG.DEVICE_PRODUCT_ID'),
        },
      ];

      if (!tags.length) {
        return defaultTags;
      }

      return defaultTags.filter(tag => tags.includes(tag.value));
    },

    getStatsRangeFilters(ranges = []) {
      const defaultRanges = [
        {
          value: 'last-week',
          label: this.$t('APP.STATS.FILTERS.RANGE.LAST_WEEK'),
        },
        {
          value: 'last-month',
          label: this.$t('APP.STATS.FILTERS.RANGE.LAST_MONTH'),
        },
        {
          value: 'last-three-months',
          label: this.$t('APP.STATS.FILTERS.RANGE.LAST_THREE_MONTHS'),
        },
        {
          value: 'last-six-months',
          label: this.$t('APP.STATS.FILTERS.RANGE.LAST_SIX_MONTHS'),
        },
        // {
        //   value: 'last-year',
        //   label: this.$t('APP.STATS.FILTERS.RANGE.LAST_YEAR')
        // }
      ];

      if (!ranges.length) {
        return defaultRanges;
      }

      return defaultRanges.filter(range => ranges.includes(range.value));
    },

    getStatsTypeFilters(types = []) {
      const defaultTypes = [
        {
          value: 'amount',
          label: this.$t('APP.STATS.FILTERS.TYPE.AMOUNT'),
        },
        {
          value: 'count',
          label: this.$t('APP.STATS.FILTERS.TYPE.COUNT'),
        },
      ];

      if (!types.length) {
        return defaultTypes;
      }

      return defaultTypes.filter(type => types.includes(type.value));
    },
  },
};
